import React from "react";
import {ConfigProvider} from "antd";
import {getLoginTheme} from "./LoginThemes";
import "./aviron/aviron-login.less";

// Applies the application's login theme (antd tokens, page background, scoped styles) to an auth page.
// The wrapper elements are always rendered, so switching the theme (e.g. once the application
// has loaded) never remounts the page, which would reset its state; with the original theme they
// add no styling and, through display: contents, no layout either.
// ConfigProvider always gets a theme object: it only adds its token provider when one is set,
// so going from undefined to a theme would change the tree. An empty one inherits the app's theme.
function LoginThemeScope({application, children}) {
  const loginTheme = getLoginTheme(application);
  const antdTheme = loginTheme.getAntdTheme ? loginTheme.getAntdTheme(application) : {};
  const style = loginTheme.className ? loginTheme.getStyle?.(application) : {display: "contents"};

  return (
    <ConfigProvider theme={antdTheme}>
      <div className={loginTheme.className} style={style}>
        {children}
      </div>
    </ConfigProvider>
  );
}

export default LoginThemeScope;
